import {BadgeVariant} from "@interstate/components/Badge";
import {ArrowTopRightOnSquareIcon} from "@interstate/components/Icons";
import {BoidAssignmentStatus} from "../model";
import {BadgeMetadata} from "../../../badges";

const variantForStatus = (status: BoidAssignmentStatus): BadgeVariant => {
  switch (status) {
    case "assigned":
      return "success";
    case "orphaned":
      return "info";
    case "available":
      return "light";
    case "unavailable":
      return "error";
    default:
      return "light";
  }
};

export const editTableBadgeMetaData = (
  status: BoidAssignmentStatus
): BadgeMetadata => {
  return {
    labelKey: `entity-detail.boid-assignment-status.${status}`,
    variant: variantForStatus(status),
    endIcon:
      status === "unavailable" ? <ArrowTopRightOnSquareIcon /> : undefined
  };
};
